import React from 'react'
import { DetailedPaper } from '@cpsy-rmap-project/web-core/repositories'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { useSnackbar } from 'notistack'
import { useUsecasePaper } from '../../../usecases/paper'
import { useLoading } from '../../atoms/Loading'
import { usePaperDetailsModal } from '../../molecules/PaperDetailsModal/hooks'
// import { usePaper } from '../../organisms/Paper'

export const Component: React.FC<{ paper: DetailedPaper }> = ({ paper }) => {
  // Paper State
  // const { handler } = usePaper()

  const [open, setOpen] = React.useState(false)
  const { handlePaperDetailsModalClose } = usePaperDetailsModal()
  const { deletePaper } = useUsecasePaper()
  const { handleIsLoading } = useLoading()
  const snackbar = useSnackbar()

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleDelete = async () => {
    handleIsLoading(true)
    try {
      // delete処理（DB登録＋内部Papers更新）
      /* const deletedPaper = */ await deletePaper(paper)
      // handler.delete(deletedPaper)
      //
      snackbar.enqueueSnackbar('Successfully deleted.', {
        variant: 'success'
      })
      handleClose()
      handlePaperDetailsModalClose()
    } catch (error) {
      console.log('error', error)
      snackbar.enqueueSnackbar('Oops! something went wrong.', {
        variant: 'error'
      })
      handleClose()
    } finally {
      handleIsLoading(false)
    }
  }

  return (
    <>
      <Box style={{ textAlign: 'center', margin: '10px' }}>
        <Button variant="text" color="secondary" size="small" onClick={handleClickOpen}>
          ⚠ Delete ⚠
        </Button>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">⚠ Delete this paper?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Once deleted, you cannot restore this paper. Do you really want to delete it?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
          <Button onClick={handleClose} color="default" autoFocus>
            Cancel
          </Button>
          <Button
            onClick={async () => {
              await handleDelete()
            }}
            color="secondary"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Component
